<div *ngIf="item" [class]="class" class="toast shadow show" [class]="item.type" role="alert">
  <div class="toast-body d-flex align-items-center justify-content-between">
    <ng-container [ngSwitch]="item.type">
      <i *ngSwitchCase="'info'" class="fs-4 fa fa-info-circle mx-3"></i>
      <i *ngSwitchCase="'success'" class="fs-4 fa fa-check-circle mx-3"></i>
      <i *ngSwitchCase="'warning'" class="fs-4 fa fa-exclamation-circle mx-3"></i>
      <i *ngSwitchCase="'danger'" class="fs-5 fa fa-exclamation-triangle mx-3"></i>
    </ng-container>

    <div class="text-start w-100">
      <h6>{{item.data.header}}</h6>
      <p>{{item.data.message}}</p>

      <div *ngIf="actions.length !== 0">
        <button
          type="button"
          role="button"
          [title]="action.text"
          [class]="action.cssClass"
          (click)="onAction(action)"
          class="btn btn-outline-dark"
          *ngFor="let action of actions"
        >
          {{action.text}}
        </button>
      </div>
    </div>

    <button type="Fechar" class="btn-close text-xs mx-2" (click)="onHide()"></button>
  </div>
</div>

<div *ngIf="show && !item" [class]="class">
  <div class="toast show" [class]="type" role="alert">
    <div class="toast-body d-flex align-items-center justify-content-between">
      <ng-container [ngSwitch]="type">
        <i *ngSwitchCase="'info'" class="fs-4 fa fa-circle-info mx-3"></i>
        <i *ngSwitchCase="'success'" class="fs-4 fa fa-check-circle mx-3"></i>
        <i *ngSwitchCase="'warning'" class="fs-4 fa fa-exclamation-circle mx-3"></i>
        <i *ngSwitchCase="'danger'" class="fs-5 fa fa-exclamation-triangle mx-3"></i>
      </ng-container>

      <div class="text-start w-100">{{message}}</div>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
